import { FormEvent, ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { EditClientFormValues } from '../Form/types';
import { Input } from '~/components';
import { FORM_VALIDATORS } from '../Form/constants';
import { MaskCnpj, MaskPhone } from '~/helpers/maskInputs';

interface ControlledInputProps {
  label: string;
  name: keyof EditClientFormValues;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  mask?: 'phone' | 'cnpj';
}

export function ControlledInput({
  disabled,
  label,
  name,
  placeholder,
  onChange,
  mask,
}: Readonly<ControlledInputProps>): ReactElement {
  const { control } = useFormContext<EditClientFormValues>();

  function changeValueByMask(event: FormEvent<HTMLInputElement>): FormEvent<HTMLInputElement> {
    const value = (event.target as HTMLInputElement).value;
    const newValue = mask === 'cnpj' ? MaskCnpj(value) : MaskPhone(value);
    const newEvent = {
      ...event,
      target: {
        ...event.target,
        value: newValue,
      },
    };
    return newEvent;
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={FORM_VALIDATORS[name]}
      render={({
        field: {
          onChange: onFieldChange, onBlur, value,
        }, fieldState,
      }) => (
        <Input
          label={label}
          placeholder={placeholder}
          onInput={(event) => {
            if (mask) {
              const newEvent = changeValueByMask(event);
              onFieldChange(newEvent);
              if (onChange) onChange((newEvent.target as HTMLInputElement).value);
            } else {
              onFieldChange(event);
              if (onChange) {
                onChange((event.target as HTMLInputElement).value);
              }
            }
          }}
          onBlur={onBlur}
          value={value as string}
          error={fieldState.error?.message}
          disabled={disabled}
        />
      )}
    />
  );
}
